import { RESET_FRAGMENTS, SET_FRAGMENT } from './actions'

export const fragments = (state = null, action) => {
  switch (action.type) {
    case SET_FRAGMENT: {
      let id = ''
      id += action.fragment.titleid // LayerId
      id += action.fragment.fragmentid // FragmentId
      return Object.assign({}, state, {
        [id]: Object.assign({}, state[id], action.fragment)
      })
    }
    case RESET_FRAGMENTS:
      return []
    default:
      return state
  }
}
